import type { LucideIcon } from "lucide-react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface Props {
  icon: LucideIcon;
  iconClass?: string;
  label: string;
  value: string;
  testId: string;
}

export function SecondaryStatCard({ icon: Icon, iconClass, label, value, testId }: Props) {
  return (
    <Card className="flex items-center gap-4 px-5 py-4" data-testid={testId}>
      <div
        className={cn(
          "w-10 h-10 rounded-full flex items-center justify-center shrink-0",
          iconClass ?? "bg-muted text-muted-foreground"
        )}
      >
        <Icon className="w-5 h-5" aria-hidden="true" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs text-muted-foreground">{label}</p>
        <h3 className="text-2xl font-bold leading-tight truncate">{value}</h3>
      </div>
    </Card>
  );
}
